<template>
  <layout-default :hide-footer-mobile="true">
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
      integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
      crossorigin="anonymous"
    />
    <steps-header
      :current-step="4"
      extra-class="steps-component-payment-page"
    ></steps-header>

    <div
      class="step-4-content"
      data-aos="fade-left"
      data-aos-duration="1500"
      data-aos-once="true"
    >
      <div class="pdv-container">
        <div class="custom-padding">
          <div class="div-alinear relative">
            <div class="item1">
              <div class="custom-acordeon">
                <div class="accordion" id="accordionInfo">
                  <div class="card">
                    <div
                      class="card-header"
                      id="headingOne"
                      :class="{ disabled: formsComplete[0] }"
                    >
                      <button
                        class="acordeon-button"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        :disabled="formsComplete[0]"
                      >
                        <p>Datos apoderado/a financiero/a</p>
                        <img
                          src="/images/featured/down-acordeon-arrow.svg"
                          alt="down-acordeon-arrow"
                        />
                      </button>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionInfo"
                    >
                      <div class="card-body">
                        <form
                          id="programInscription"
                          autocomplete="none"
                          @submit.prevent="
                            ifFormValid($event, () => onSaveForm(0))
                          "
                        >
                          <div class="row">
                            <div class="col-12">
                              <div class="pdv-form-group">
                                <div class="row custom-pdv-row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="inscriptionName"
                                        >Nombres del apoderado/a</label
                                      >
                                      <input
                                        type="text"
                                        v-model="financingPartyData.name"
                                        name="nombre"
                                        id="inscriptionName"
                                        onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                                        maxlength="30"
                                      />
                                      <p
                                        v-if="
                                          errorMens &&
                                          financingPartyData.name == ''
                                        "
                                        class="error-otp"
                                      >
                                        Debes agregar un Nombre
                                      </p>
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Primer apellido</label>
                                      <input
                                        type="text"
                                        v-model="
                                          financingPartyData.fatherLastName
                                        "
                                        name="apellidoPaterno"
                                        onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                                        maxlength="12"
                                      />
                                    </div>
                                  </div>

                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Segundo apellido</label>
                                      <input
                                        type="text"
                                        v-model="
                                          financingPartyData.motherLastName
                                        "
                                        name="apellidoMaterno"
                                        onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
                                        maxlength="12"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">RUT</label>
                                      <vue-mask
                                        mask="00.000.000-K"
                                        :raw="false"
                                        v-model="financingPartyData.rut"
                                        @blur="() => checkEmail()"
                                        :options="{
                                          reverse: true,
                                          translation: {
                                            K: { pattern: /[0-9kK]/ },
                                          },
                                        }"
                                        name="rut"
                                      ></vue-mask>
                                      <p
                                        v-if="
                                          errorMens &&
                                          financingPartyData.rut == ''
                                        "
                                        class="error-otp"
                                      >
                                        Debes agregar un Rut
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Celular</label>
                                      <the-mask
                                        mask="+569 ## ## ####"
                                        :masked="true"
                                        v-model="financingPartyData.phone"
                                        type="tel"
                                        name="cel"
                                      ></the-mask>
                                    </div>
                                  </div>
                                </div>
                                <div class="recomendation">
                                  <!--div class="img-content">
                                    <img src="/images/recomendation_img.png" alt="recomendation_img" />
                                  </div-->
                                  <div class="text-content">
                                    <h5>Recuerda</h5>
                                    <div class="item">
                                      <div class="bullet-yellow"></div>
                                      <span
                                        ><b>No utilizar emails corporativos.</b>
                                        Puede que nuestros emails no te
                                        lleguen.</span
                                      >
                                    </div>
                                    <div class="item">
                                      <div class="bullet-yellow"></div>
                                      <span
                                        >Revisa tu casilla de
                                        <b
                                          >Spam, Promociones o Correos no
                                          deseados</b
                                        ></span
                                      >
                                    </div>
                                    <div class="item">
                                      <div class="bullet-yellow"></div>
                                      <span
                                        >Si continuas sin recibir nuestros
                                        correos, puedes comunicarte al
                                        <b> +56 2 2994 9850 </b></span
                                      >
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="email">Email</label>
                                      <div class="d-flex">
                                        <div class="d-flex flex-col">
                                          <input
                                            type="email"
                                            v-model="financingPartyData.email"
                                            name="email"
                                            maxlength="50"
                                            style="
                                              background-color: #ffffff;
                                              max-width: 260px;
                                              min-width: 260px;
                                            "
                                            @blur="() => checkEmail()"
                                            ref="emailInput"
                                          />
                                        </div>
                                        <div
                                          v-if="
                                            otp_valid &&
                                            !errorMens &&
                                            financingPartyData.email != null
                                          "
                                          style="
                                            position: relative;
                                            z-index: 20;
                                            left: -30px;
                                            top: 10px;
                                          "
                                        >
                                          <i
                                            class="fas fa-check-circle success"
                                          ></i>
                                        </div>
                                        <div class="input-container">
                                          <div
                                            v-if="
                                              !otp_valid &&
                                              !errorMens &&
                                              financingPartyData.email != null
                                            "
                                            class="error-icon"
                                          >
                                            <i
                                              class="fas fa-times-circle danger"
                                            ></i>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div
                                          v-if="
                                            !otp_valid &&
                                            !modalState &&
                                            !errorMens &&
                                            uniqueEmail
                                          "
                                          class="disclaimer-info-otp"
                                          @click="() => checkEmail()"
                                        >
                                          <div class="validador-container">
                                            <div>
                                              <i class="fas fa-info-circle"></i>
                                              <p class="otp-first-disclaimer">
                                                Necesitaremos validar tu correo.
                                              </p>
                                            </div>
                                            <div>
                                              <p
                                                class="otp-first-disclaimer validar"
                                              >
                                                Validar correo
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Dirección</label>
                                      <input
                                        v-model="financingPartyData.address"
                                        type="text"
                                        name="direccion"
                                        maxlength="30"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Número</label>
                                      <input
                                        v-model="financingPartyData.address2"
                                        type="text"
                                        name="dirNumero"
                                        onkeypress="return /[0-9]/i.test(event.key)"
                                        maxlength="5"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <label for="">Departamento</label>
                                      <input
                                        v-model="financingPartyData.address3"
                                        type="text"
                                        name="dirDepartamento"
                                        maxlength="5"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div class="pdv-form-group">
                                  <div class="row form-group">
                                    <div class="col-md-6 col-12">
                                      <typeahead
                                        :data="availableRegions"
                                        propName="name"
                                        :selected="financingPartyData.regionId"
                                        @clear="
                                          () =>
                                            (financingPartyData.regionId = null)
                                        "
                                        label="Región"
                                        placeholder="Selecciona tu región"
                                        @onSelect="onSelectRegion"
                                      >
                                      </typeahead>
                                      <input
                                        autocomplete="none"
                                        class="withErrorContainer input-hidden-college"
                                        :value="financingPartyData.regionId"
                                        :name="'region-' + timestamp"
                                      />
                                      <div class="col-12">
                                        <div class="errorContainer"></div>
                                      </div>
                                    </div>

                                    <div class="col-md-6 col-12">
                                      <typeahead
                                        :data="availableCities"
                                        propName="name"
                                        :selected="financingPartyData.cityId"
                                        :disabled="!financingPartyData.regionId"
                                        @clear="
                                          () =>
                                            (financingPartyData.cityId = null)
                                        "
                                        label="Ciudad"
                                        placeholder="Selecciona tu ciudad"
                                        @onSelect="
                                          ({ id }) =>
                                            (financingPartyData.cityId = id)
                                        "
                                      >
                                      </typeahead>
                                      <input
                                        autocomplete="none"
                                        class="withErrorContainer input-hidden-college"
                                        :value="financingPartyData.cityId"
                                        :name="'ciudad-' + timestamp"
                                      />
                                      <div class="col-12">
                                        <div class="errorContainer"></div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row form-group">
                                    <div class="col-10 col-md-6">
                                      <typeahead
                                        :data="availableCommunes"
                                        propName="name"
                                        :disabled="!financingPartyData.regionId"
                                        :selected="financingPartyData.communeId"
                                        @clear="
                                          () =>
                                            (financingPartyData.communeId =
                                              null)
                                        "
                                        label="Comuna"
                                        placeholder="Selecciona tu ciudad"
                                        @onSelect="
                                          ({ id }) =>
                                            (financingPartyData.communeId = id)
                                        "
                                      >
                                      </typeahead>
                                      <input
                                        autocomplete="none"
                                        class="withErrorContainer input-hidden-college"
                                        :value="financingPartyData.communeId"
                                        :name="'comuna-' + timestamp"
                                      />
                                    </div>
                                    <div class="col-12">
                                      <div class="errorContainer"></div>
                                    </div>
                                  </div>
                                </div>

                                <div class="w-full">
                                  <button
                                    type="submit"
                                    class="boton-new-primario boton-new-mediano w-full"
                                    :disabled="otp_valid == false"
                                  >
                                    Guardar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="acordeon-separator"></div>

                <div :key="index" v-for="(student, index) in students">
                  <div class="accordion" id="accordionInfo2">
                    <div class="card">
                      <div
                        class="card-header"
                        id="headingTwo"
                        :class="{
                          disabled:
                            formsComplete[index + 1] || !formsComplete[index],
                        }"
                      >
                        <button
                          class="acordeon-button"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                          :disabled="
                            formsComplete[index + 1] || !formsComplete[index]
                          "
                        >
                          <p>DATOS DE {{ student.name.toUpperCase() }}</p>
                          <img
                            src="/images/featured/down-acordeon-arrow.svg"
                            alt="down-acordeon-arrow"
                          />
                        </button>
                      </div>
                      <div
                        id="collapseTwo"
                        class="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionInfo2"
                      >
                        <div class="card-body">
                          <form
                            v-if="studentsData.length > 0"
                            :class="{
                              show:
                                !formsComplete[index + 1] && formsComplete[0],
                            }"
                            autocomplete="none"
                            class="collapse"
                            :id="'alumnForm' + index"
                            data-parent="#formsList"
                            @submit.prevent="
                              ifFormValid($event, () => onSaveForm(index + 1))
                            "
                          >
                            <div class="row">
                              <div class="col-12">
                                <div class="info-collected">
                                  <div class="info-collected-item">
                                    <span class="key"
                                      >Nombre del estudiante</span
                                    >
                                    <p class="value">
                                      {{
                                        student.name +
                                        " " +
                                        student.fatherLastName +
                                        " " +
                                        student.lastName
                                      }}
                                    </p>
                                  </div>

                                  <div class="info-collected-item">
                                    <span class="key">RUT</span>
                                    <p class="value">{{ student.rut }}</p>
                                  </div>
                                </div>
                                <div>
                                  <div class="pdv-form-group">
                                    <div class="row">
                                      <div class="col-12 col-md-6">
                                        <div class="pdv-form-group form-group">
                                          <label for="">Email </label>
                                          <input
                                            class="withErrorContainer"
                                            type="email"
                                            v-model="studentsData[index].email"
                                            name="email"
                                            maxlength="50"
                                          />
                                          <div class="col-12">
                                            <div class="errorContainer"></div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6 col-12">
                                        <div class="form-group">
                                          <label for=""
                                            >Fecha de Nacimiento
                                          </label>
                                          <vue-mask
                                            placeholder="dd/mm/aaaa"
                                            mask="DA/MO/YEXR"
                                            :raw="false"
                                            v-model="
                                              studentsData[index].birthday
                                            "
                                            :options="dateMaskOptions"
                                            name="fecha"
                                          ></vue-mask>
                                          <div class="col-12">
                                            <div class="errorContainer"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div class="col-md-6 col-12">
                                        <div class="form-group">
                                          <label for="">Celular</label>
                                          <the-mask
                                            type="tel"
                                            class="withErrorContainer"
                                            name="cel"
                                            v-model="studentsData[index].phone"
                                            :masked="true"
                                            mask="+569 ## ## ####"
                                          ></the-mask>
                                          <div class="col-12">
                                            <div class="errorContainer"></div>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="col-12 col-md-6"
                                        v-if="availableStudentsRegion[index]"
                                      >
                                        <div class="form-group">
                                          <typeahead
                                            :data="
                                              availableStudentsRegion[index]
                                            "
                                            propName="name"
                                            :selected="
                                              studentsData[index].regionId
                                            "
                                            @clear="
                                              () =>
                                                (studentsData[index].regionId =
                                                  null)
                                            "
                                            label="Región del Colegio"
                                            placeholder="Selecciona tu región"
                                            @onSelect="
                                              ({ id }) =>
                                                onSelectStudentRegion(id, index)
                                            "
                                          >
                                          </typeahead>
                                          <input
                                            autocomplete="none"
                                            class="withErrorContainer input-hidden-college"
                                            :value="
                                              studentsData[index].regionId
                                            "
                                            :name="'region-' + timestamp"
                                          />
                                          <div class="col-12">
                                            <div class="errorContainer"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="row"
                                      v-if="availableStudentsRegion[index]"
                                    >
                                      <div class="col-12 col-md-6">
                                        <div class="form-group">
                                          <typeahead
                                            :data="
                                              availableStudentsCommunes[index]
                                            "
                                            propName="name"
                                            :disabled="
                                              !studentsData[index].regionId
                                            "
                                            :selected="
                                              studentsData[index].communeId
                                            "
                                            @clear="
                                              () =>
                                                (studentsData[index].communeId =
                                                  null)
                                            "
                                            label="Comuna del Colegio"
                                            placeholder="Selecciona tu comuna"
                                            @onSelect="
                                              ({ id }) =>
                                                onSelectCommune(id, index)
                                            "
                                          >
                                          </typeahead>
                                          <input
                                            autocomplete="none"
                                            class="withErrorContainer input-hidden-college"
                                            :value="
                                              studentsData[index].communeId
                                            "
                                            :name="'comuna-' + timestamp"
                                          />
                                          <div class="col-12">
                                            <div class="errorContainer"></div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-12 col-md-6">
                                        <div class="form-group">
                                          <typeahead
                                            :data="
                                              availableStudentsColleges[index]
                                            "
                                            propName="name"
                                            :disabled="
                                              !studentsData[index].communeId
                                            "
                                            :selected="
                                              studentsData[index].establishment
                                            "
                                            @clear="
                                              () =>
                                                (studentsData[
                                                  index
                                                ].establishment = null)
                                            "
                                            label="Colegio"
                                            placeholder="Elige tu colegio"
                                            @onSelect="
                                              ({ id }) =>
                                                collegesHandler(id, index)
                                            "
                                          >
                                          </typeahead>
                                          <input
                                            autocomplete="none"
                                            class="withErrorContainer input-hidden-college"
                                            v-model="
                                              studentsData[index].establishment
                                            "
                                            :name="'colegio-' + timestamp"
                                          />
                                          <div class="col-12">
                                            <div class="errorContainer"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      v-if="availableStudentsRegion[index]"
                                      class="row"
                                    >
                                      <div class="col-md-6 col-12">
                                        <div class="form-group">
                                          <label for=""
                                            >Año de Egreso IV Medio</label
                                          >
                                          <select
                                            v-select2="
                                              studentsData[index].graduationYear
                                            "
                                            class="withErrorContainer yearsSelected"
                                            v-model="
                                              studentsData[index].graduationYear
                                            "
                                            name="añoGraduacion"
                                          >
                                            <option
                                              v-for="year in selectYears"
                                              :key="year"
                                              :value="year"
                                            >
                                              {{ year }}
                                            </option>
                                          </select>
                                          <div class="col-12">
                                            <div class="errorContainer"></div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6 col-12">
                                        <div class="form-group">
                                          <div class="col-12">
                                            <label
                                              for=""
                                              class="validanumbers"
                                              id=""
                                              >NEM (Sólo número y
                                              decimal)</label
                                            >
                                          </div>
                                          <div
                                            class="col-md-12 col-12 position-relative"
                                          >
                                            <the-mask
                                              :masked="true"
                                              :mask="'N,D'"
                                              :tokens="{
                                                N: { pattern: /[4-7]/ },
                                                D: { pattern: /[0-9]/ },
                                              }"
                                              type="text"
                                              class="withErrorContainer"
                                              v-model="
                                                studentsData[index].averageScore
                                              "
                                              @input="validateInput(index)"
                                              name="promedio"
                                            />
                                            <span
                                              class="error-message"
                                              v-if="error"
                                              >El promedio debe estar entre 4,0
                                              y 7,0</span
                                            >
                                          </div>
                                          <div class="col-12">
                                            <div class="errorContainer"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="w-full">
                                  <button
                                    type="submit"
                                    class="boton-new-primario boton-new-mediano w-full mt-4"
                                    :disabled="error"
                                  >
                                    Guardar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="formsComplete.every((f) => !!f)"
                class="pdv-submit-button mt-4"
              >
                <div class="pdv-form-group row">
                  <div class="col">
                    <div class="form-group">
                      <div class="custom-checkbox-cont">
                        <input
                          v-model="accept"
                          type="checkbox"
                          id="terms"
                          name="terminos"
                          class="default withErrorContainer"
                        />
                        <label for="terms" class="checkbox-label">
                          <div
                            class="pdv-custom-checkbox mr-3"
                            :class="{ chequiado: accept }"
                          >
                            <img src="/images/iconos/icon-check.svg" alt="" />
                          </div>

                          <div class="check-box-text">
                            <span
                              >Por este acto el estudiante y/o su apoderado/a,
                              declaran que leyeron el Contrato de Prestación de
                              Servicios Educacionales que se suscribe, así como
                              la totalidad de sus anexos. Al mismo tiempo,
                              declaran su completa conformidad con sus
                            </span>
                            <a
                              :href="ruleBook"
                              target="_blank"
                              class="underline-link underline-link--secondary"
                              >TÉRMINOS Y CONDICIONES</a
                            >
                          </div>
                        </label>

                        <div class="errorContainer"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="w-full">
                      <div class="form-group">
                        <button
                          :class="{ disabled: !accept }"
                          @click="startTransaction"
                          ref="payButton"
                          type="button"
                          class="boton-new-primario boton-new-mediano w-full"
                        >
                          <!--vue-progress-bar></vue-progress-bar-->
                          {{
                            prices.precioTotal == 0 ? "CONTINUAR" : "IR A PAGAR"
                          }}
                        </button>
                      </div>
                      <!--img class="img-webpay" src="/images/webpay.png" alt="" v-if="prices.precioTotal > 0" /-->
                    </div>
                  </div>
                </div>
              </div>
              <form
                id="webpayForm"
                :action="webpay ? webpay.url : ''"
                method="post"
                class="hidden-form"
              >
                <input
                  type="hidden"
                  name="token_ws"
                  :value="webpay ? webpay.token : ''"
                />
                <button type="submit">Enviar</button>
              </form>
            </div>
            <div class="item2">
              <img
                src="/images/featured/boys-books-computers-group.svg"
                alt="boys-books-computers-group"
                class="imagen-pensar"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="modalState" class="modal-step-4">
        <div class="modal-content-step4">
          <div class="otp-div">
            <!--button
                @click="() => (modalState = false)"
                class="d-flex justify-content-end"
            >
              X
            </button-->
            <div class="d-flex justify-content-end modal-step-4-header">
              <a
                href="#"
                @click.prevent="() => (modalState = false)"
                class="btn-close"
              >
                X
              </a>
            </div>
            <h2>ANTES DE CONTINUAR...</h2>
            <p class="otp-info">
              Necesitamos validar tu casilla de email, por eso te enviaremos un
              código de verificación a:
              <span class="otp-info-email">{{ financingPartyData.email }}</span>
            </p>
            <div class="otp-row-padding">
              <label for="otp">Código de verificación</label>
              <div class=" ">
                <div class="col-6">
                  <input
                    type="text"
                    v-model.trim="otp_data"
                    name="otp"
                    maxlength="7"
                    class="input-otp"
                    :class="[otp_valid ? 'valido' : 'invalido']"
                    v-mask="'### ###'"
                  />
                </div>
                <div class="temporizador">
                  <p class="otp-info-clock">El código caducará en 5 min.</p>
                  <p class="otp-clock">
                    <Countdown
                      :end="otp_expires_in"
                      v-if="otp_countdown"
                      showMinutes
                      showSeconds
                    />
                  </p>
                </div>

                <div class="btn-codigo">
                  <div
                    class="boton-new-primario boton-new-largo active"
                    @click="handleOTPCode"
                  >
                    ENVIAR CÓDIGO
                  </div>
                </div>
                <div
                  v-if="otpSend && otp_valid === false && otp_data != null"
                  class="col-1 pr-0"
                >
                  <i
                    class="fas fa-times-circle danger"
                    v-if="otp_valid === false"
                  ></i>
                </div>
                <div
                  v-if="otpSend && otp_valid === false && otp_data != null"
                  class="col-11 pl-0"
                >
                  <p class="otp-error">
                    El código ingresado es inválido. Por favor, verifica el
                    código en tu correo o envía un nuevo código
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="formsList" class="container position-relative">
        <div class="d-none alert-info">
          <div>
            <img src="/images/iconos/clock-white.svg" alt="" />
            <p>Tus cupos estarán asegurados por</p>
            <span>{{ quotasTimeRemaining | timeRemaining }}</span>
          </div>
        </div>

        <a
          style="visibility: hidden"
          ref="btnCancelPay"
          data-backdrop="static"
          data-keyboard="false"
          href=".cancel-pay-modal"
          data-toggle="modal"
        ></a>
        <a
          style="visibility: hidden"
          ref="btnSuccessfulFlowModal"
          data-backdrop="static"
          data-keyboard="false"
          href=".successful-flow-modal"
          data-toggle="modal"
        ></a>
        <a
          style="visibility: hidden"
          ref="btnSuccessModalWithCoupon"
          data-backdrop="static"
          data-keyboard="false"
          href=".success-modal-with-coupon"
          data-toggle="modal"
        ></a>
        <a
          style="visibility: hidden"
          ref="btnUnknowErrorModal"
          data-backdrop="static"
          data-keyboard="false"
          href=".unknow-error-modal"
          data-toggle="modal"
        ></a>
      </div>
      <error-pay-modal @onPay="tryToPayAgain" />
      <successful-flow-modal @onContinue="redirectToWebpay" />
      <success-modal-with-coupon @onContinue="confirmInscription" />
    </div>

    <div v-if="showModal" class="modal-intensive" id="modalIntensive">
      <div class="content realtive">
        <!--div class="header">
          <img src="/images/featured/close-circle-menu.svg" alt="close-circle-menu" class="btn-modal" @click="closeModal" /> 
        </div-->

        <img
          src="/images/featured/imageModalLoading.svg"
          alt="imageModalLoading"
          class="img-modal-loading"
        />
        <div class="text-content">
          <div class="d-flex justify-content-center mb-4">
            <img
              src="/images/featured/IconButtonRelod.svg"
              alt="IconButtonRelod"
            />
          </div>
          <h5>Espera un momento mientras procesamos tu solicitud</h5>
          <p>Esto puede demorar unos segundos.</p>
        </div>
      </div>
    </div>
  </layout-default>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as moment from "moment";
import ErrorPayModal from "@/components/modals/ErrorPayModal";
import SuccessfulFlowModal from "@/components/modals/SuccessfulFlowModal";
import SuccessModalWithCoupon from "@/components/modals/SuccessModalWithCoupon";
import LayoutDefault from "@/layouts/Default";
import StepsHeader from "@/components/StepsHeader";
import Typeahead from "@/components/Typeahead";
import formValidation from "@/mixins/formValidation";
import vueMask from "vue-jquery-mask";
import { orderBy } from "@/helpers";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Countdown from "countdown-vue";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

global.jQuery = require("jquery");
const $ = global.jQuery;
window.$ = $;

export default {
  components: {
    Countdown,
    LayoutDefault,
    StepsHeader,
    ErrorPayModal,
    SuccessfulFlowModal,
    SuccessModalWithCoupon,
    vueMask,
    // VueBootstrapTypeahead,
    Typeahead,
  },

  data() {
    return {
      uniqueEmail: true,
      errorMens: false,
      modalState: false,
      error: false,
      prev_otp: false,
      otp_valid: false,
      otpSend: false,
      otp_countdown: null,
      otp_expires_in: null,
      otp_interval: null,
      otp: false,
      otp_data: null,
      timestamp: Date.now(),
      sharedRegions: [],
      availableRegions: [],
      availableCities: [],
      availableCommunes: [],
      availableStudentsRegion: [],
      availableStudentsCommunes: [],
      availableStudentsColleges: [],
      availableStudentsServerColleges: [],
      financingPartyData: {
        name: "",
        fatherLastName: null,
        motherLastName: null,
        lastName: null,
        rut: "",
        email: null,
        phone: "+569 ",
        regionId: null,
        cityId: null,
        communeId: null,
        address: null,
        address2: null,
        address3: null,
      },
      studentsData: [],
      webpay: null,
      accept: false,
      formsComplete: [false],
      dateMaskOptions: {
        // These are the initial regex
        translation: {
          D: { pattern: /[0-3]/ },
          A: { pattern: /[0-9]/ },
          M: { pattern: /[0-1]/ },
          O: { pattern: /[0-9]/ },
          Y: { pattern: /[1-2]/ },
          E: { pattern: /[90]/ },
          X: { pattern: /[0-9]/ },
          R: { pattern: /[0-9]/ },
        },

        onKeyPress: function (cep, event, currentField, options) {
          if (!cep) return;
          let m = cep.match(/(\d{1})/g);
          if (!m) return;

          if (parseInt(m[0]) === 3) {
            options.translation.A.pattern = /[0-1]/;
          } else if (parseInt(m[0]) === 0) {
            options.translation.A.pattern = /[1-9]/;
          } else {
            options.translation.A.pattern = /[0-9]/;
          }

          if (parseInt(m[2]) === 1) {
            options.translation.O.pattern = /[0-2]/;
          } else {
            options.translation.O.pattern = /[1-9]/;
          }

          if (parseInt(m[4]) === 2) {
            options.translation.E.pattern = /[0]/;
          } else {
            options.translation.E.pattern = /[9]/;
          }

          if (parseInt(m[5]) === 0) {
            options.translation.X.pattern = /[0-9]/;
          } else {
            options.translation.X.pattern = /[0-9]/;
          }

          if (parseInt(m[6]) === 0 && parseInt(m[5]) === 0) {
            options.translation.R.pattern = /[0-9]/;
          } else {
            options.translation.R.pattern = /[0-9]/;
          }

          let temp_value = currentField.val();
          currentField.val("");
          currentField.unmask().mask("DA/MO/YEXR", options);
          currentField.val(temp_value);
        },
      },
      averageScoreMask: "##",
      showModal: false,
    };
  },

  mixins: [formValidation],

  computed: {
    ...mapState(["quotasTimeRemaining"]),
    ruleBook() {
      if (!this.selectedLocation) {
        return process.env.VUE_APP_PDV_RULEBOOK_CONTRACT;
      } else {
        if (this.selectedLocation.name.includes("San Miguel")) {
          return process.env.VUE_APP_PDV_RULEBOOK_CONTRACT_SM;
        } else {
          return process.env.VUE_APP_PDV_RULEBOOK_CONTRACT;
        }
      }
    },
    selectYears() {
      let currentYear = new Date().getFullYear();
      return Array(33)
        .fill({})
        .map((x, i) => currentYear + 5 - i);
    },
    students() {
      return this.$store.state.students;
    },
    selectedLocation() {
      return this.$store.state.selectedLocation;
    },
    prices() {
      return this.$store.state.students[0].prices;
    },
  },

  watch: {
    modalState(newVal) {
      if (newVal) {
        window.scrollTo(0, 0); // Desplaza hacia la parte superior cuando modalState es true
      }
    },
  },

  destroyed() {
    clearInterval(this.otp_interval);
  },
  methods: {
    ...mapActions(["setQuotasTimeRemaining", "setCoursesNotAvailables"]),
    dateFormat(val) {
      let birthday = val;
      let format = "YYYY-MM-DD";
      if (birthday) {
        format =
          birthday.split("-")[0].length === 4 ? "YYYY-MM-DD" : "DD-MM-YYYY";
      }
      return moment(birthday, format).format("DD-MM-YYYY");
    },
    validEmail: function (email) {
      var re =
        /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
      return re.test(email);
    },
    validateInput(index) {
      let score = this.studentsData[index].averageScore;

      // Verificar si el formato es válido: números de 4,0 a 7,0
      const validPattern = /^[4-6],[0-9]$|^7,0$/;
      if (!validPattern.test(score)) {
        // Si el número empieza con 7 y tiene un decimal distinto de 0, lo corregimos a 7,0
        if (score.startsWith("7,")) {
          this.studentsData[index].averageScore = "7,0";
          this.error = false;
        } else {
          this.error = true;
        }
      } else {
        this.error = false;
      }
    },
    async checkEmail() {
      this.otp_valid = false;

      // console.log("checkeo mails.");
      if (
        this.financingPartyData.name == "" ||
        this.financingPartyData.rut == "" ||
        !this.validEmail(this.financingPartyData.email)
      ) {
        this.errorMens = true;

        return;
      }

      this.errorMens = false;
      // console.log("pase validacion");
      const statusFinancialParty = await this.saveFinancingParty(false);
      // console.log("status", statusFinancialParty);
      if (!statusFinancialParty) {
        return;
      }
      // console.log("grabe en base de datos y el email deberia de ser único");
      const [{ data: otp_status }, { data: otp_state }] = await Promise.all([
        this.Axios.get(`/otp/email/${this.financingPartyData.email}`),
        this.Axios.get(
          `/financingParties/email/${this.financingPartyData.email}`
        ),
      ]);

      console.log(otp_status, otp_state);

      if (otp_status.status && otp_state.otpstate) {
        this.otpSend = false;
        this.otp = false;
        this.otp_data = null;
        this.prev_otp = false;
        this.otp_valid = true;
      } else {
        this.prev_otp = true;
        this.modalState = true;
        this.otp_valid = false;
        this.$nextTick(() => {
          this.$refs.emailInput.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        });
        this.otp_data = null;
        this.handleOtp();
      }
    },
    async handleOTPCode() {
      if (this.otp_data.replace(/\s+/g, "").length < 6) return;
      this.otpSend = true;
      const { data: mensaje } = await this.Axios.put(
        `/otp/${this.financingPartyData.email}`,
        {
          email: this.financingPartyData.email,
          rut: this.financingPartyData.rut,
          name: this.financingPartyData.name,
          code: this.otp_data.replace(/\s+/g, ""),
        }
      ).then((res) => {
        if (res.data == "Valido RUT y Email") {
          this.otp_valid = true;
          this.prev_otp = false;
          this.otpSend = false;
          this.$swal.fire({
            position: "center",
            icon: "success",
            title: "¡Código correcto!",
            showConfirmButton: false,
            timer: 2500,
          });
          this.otp_data = null;
          this.modalState = false;
        } else {
          this.otp_valid = false;
        }
      });
    },
    handleOtp() {
      const respuesta = this.Axios.post("/otp", {
        email: this.financingPartyData.email,
        rut: this.financingPartyData.rut,
        name: this.financingPartyData.name,
      });
      // console.log(respuesta);
      const registro = Date.now();
      this.otp_expires_in = moment(registro).add(5, "minutes");

      this.otp_countdown = true;
      // console.log(this.otp_expires_in);
    },
    async confirmInscription() {
      try {
        const { data: order } = await this.Axios.post("/orders-confirm", {
          orderId: localStorage.ordenID,
        });
        window.location.replace(
          `informacion-compra?buyOrder=${order.buyOrder}&no=${order.order.id}`
        );
      } catch (error) {
        console.log(error);
      }
    },
    async startTransaction() {
      //this.$Progress.start();
      this.showModal = true;
      try {
        const { data: order } = await this.Axios.put(
          "/orders",
          this.$store.state.fullOrder
        );
        this.webpay = {
          url: order.url,
          token: order.token,
        };

        console.log("order", order);

        //validar que si es = muestre otro modal

        let promises = this.students.map((student) => {
          return this.Axios.put(`/students/${student.id}`, {
            financingPartyId: order.financingPartyId,
            caretakerId: order.caretakerId,
          });
        });
        await Promise.all(promises);
        if (order.url == null && order.token == null) {
          this.showModal = false;
          this.$refs.btnSuccessModalWithCoupon.click();
        } else {
          this.showModal = false;
          this.$refs.btnSuccessfulFlowModal.click();
        }
      } catch (err) {
        if (err.response.data.name === "CourseNotAvailable") {
          this.showModal = false;
          this.setCoursesNotAvailables(err.response.data.coursesNotAvailables);
        } else if (err.response.data.name === "UnknowError") {
          this.showModal = false;
          this.$refs.btnUnknowErrorModal.click();
        }
      }
      //this.$Progress.finish();
    },
    rehydrate() {
      this.financingPartyData = {
        name: this.$store.state.financingParty.name || "",
        fatherLastName: this.$store.state.financingParty.fatherLastName || null,
        motherLastName: this.$store.state.financingParty.motherLastName || null,
        lastName: this.$store.state.financingParty.lastName || null,
        rut: this.$store.state.financingParty.rut || "",
        email: this.$store.state.financingParty.email || null,
        phone: this.$store.state.financingParty.phone || "+569 ",
        regionId: null,
        cityId: null,
        communeId: null,
        address: this.$store.state.financingParty.address || null,
        address2: this.$store.state.financingParty.address2 || null,
        address3: this.$store.state.financingParty.address3 || null,
      };
      this.studentsData.push(
        ...this.students.map((s) => ({
          email: s.email || "",
          phone: s.phone || "+569 ",
          establishment: "",
          graduationYear: s.graduationYear || null,
          birthday: this.dateFormat(s.birthday),
          careerPath: s.careerPath || "pdv",
          regionId: null,
          communeId: null,
          averageScore: null,
        }))
      );
    },
    redirectToWebpay() {
      document.getElementById("webpayForm").submit();
    },
    async saveFinancingParty(gestionarCollapse) {
      this.financingPartyData.lastName = `${this.financingPartyData.fatherLastName} ${this.financingPartyData.motherLastName}`;
      try {
        const { data: financingParty } = await this.Axios.post(
          "/financingParties",
          this.financingPartyData
        );

        await this.$store.dispatch(
          "addFinancingPartyInfo",
          this.financingPartyData
        );
        let sessionState = {
          students: this.students,
        };
        await this.$store.dispatch("addInfoToFullOrder", {
          financingParty: this.$store.state.financingParty,
          sessionState: JSON.stringify(sessionState),
        });

        if (gestionarCollapse) {
          const collapseOne = $("#collapseOne");
          collapseOne.removeClass("show");
          collapseOne.attr("aria-expanded", false);

          const collapseTwo = $("#collapseTwo");
          collapseTwo.addClass("show");
          collapseTwo.attr("aria-expanded", true);
        }
        return true;
      } catch (error) {
        console.log(error);
        if (error.response.status === 400) {
          if (error.response.data.message === "email must be unique") {
            this.uniqueEmail = false;
            this.$swal.fire({
              position: "center",
              icon: "warning",
              title: "¡Atención!",
              html:
                "El correo " +
                "<b>" +
                error.response.data.problemField.email +
                "</b>" +
                " ya se encuentra registrado",

              showConfirmButton: true,
            });
          }
        }
        return false;
      }
    },
    async saveStudent(studentIndex) {
      try {
        let currentStudent = this.studentsData[studentIndex];

        let info = {
          student: this.students[studentIndex],
          append: { ...currentStudent },
        };

        const { data: student } = await this.Axios.post(`/students`, {
          ...info.student,
          ...info.append,
        });

        info.student = student;

        await this.$store.dispatch("addInfoToStudent", info);
        const collapseTwo = $("#collapseTwo");
        collapseTwo.removeClass("show");
        collapseTwo.attr("aria-expanded", false);

        return true;
      } catch (error) {
        if (error.response.status === 400) {
          if (
            error.response.data.message ===
            "Error - Email address already in use!"
          ) {
            alert(
              "El correo: " +
                error.response.data.problemField.email +
                " ya se encuentra registrado"
            );
          }
        }
        return false;
      }
    },
    tryToPayAgain() {
      this.accept = true;
      setTimeout(() => {
        this.$refs.payButton.click();
      }, 500);
    },
    discountSeconds() {
      const currentTime = moment(this.quotasTimeRemaining, "mm:ss").subtract(
        1,
        "second"
      );
      this.setQuotasTimeRemaining(currentTime.format("mm:ss"));
    },
    async onSelectRegion({ id }) {
      this.availableCities = [];
      this.availableCommunes = [];
      this.financingPartyData.regionId = id;
      const regionId = this.financingPartyData.regionId;
      if (regionId) {
        const { data: cities } = await this.Axios.get(`/cities/${regionId}`);
        this.availableCities = orderBy([...cities], "name");
        const { data: communes } = await this.Axios.get(
          `/communes/${regionId}`
        );
        this.availableCommunes = orderBy([...communes], "name");
      }
    },
    async onSelectStudentRegion(id, studentIndex) {
      this.studentsData[studentIndex].regionId = id;

      const regionId = this.studentsData[studentIndex].regionId;

      this.$set(this.availableStudentsCommunes, studentIndex, []);

      if (regionId) {
        const { data: communes } = await this.Axios.get(
          `/communes/${regionId}`
        );
        this.$set(
          this.availableStudentsCommunes,
          studentIndex,
          orderBy(communes, "name")
        );
      }
    },
    async onSelectCommune(id, studentIndex) {
      this.studentsData[studentIndex].communeId = id;
      const communeId = this.studentsData[studentIndex].communeId;
      this.availableStudentsColleges[studentIndex] = [];
      this.availableStudentsServerColleges[studentIndex] = [];
      const { data } = await this.Axios.get(`colleges/${communeId}`);
      let colleges = orderBy(data, "name");
      this.$set(this.availableStudentsColleges, studentIndex, colleges);
      this.$set(this.availableStudentsServerColleges, studentIndex, colleges);
    },
    async onSaveForm(formIndex) {
      if (formIndex === 0) {
        let ok = await this.saveFinancingParty(true);
        if (ok) {
          this.$set(this.formsComplete, formIndex, true);
          $(window).scrollTop(0);
        }
      } else {
        let ok = await this.saveStudent(formIndex - 1);
        if (ok) {
          this.$set(this.formsComplete, formIndex, true);
          $(window).scrollTop(0);
        }
      }
    },
    collegesHandler(id, studentId) {
      this.studentsData[studentId].establishment = id.toString();
      const establishment = this.studentsData[studentId].establishment;
      if (establishment) {
        let college = this.availableStudentsServerColleges[studentId].filter(
          (college) => {
            return college.id === this.selectedCommune;
          }
        );
        this.$set(this.availableStudentsColleges, studentId, college);
      } else {
        this.$set(
          this.availableStudentsColleges,
          studentId,
          this.availableStudentsServerColleges[studentId]
        );
      }
    },
    getPaternNem(v) {
      if (this.studentsData.length === 0) {
        return /[0-9]/;
      } else if (this.studentsData[0].averageScore === null) {
        return /[0-9]/;
      } else {
        if (this.studentsData[0].averageScore.includes("7")) {
          this.studentsData[0].averageScore = "7.0";
          return /^-?(?:0\d*|0)$/;
        } else {
          return /[0-9]/;
        }
      }
    },
  },

  beforeDestroy() {
    clearInterval(this.otp_interval);
  },
  async created() {
    this.$store.dispatch("hideBackpack");

    this.availableRegions = [];
    const { data: regions } = await this.Axios.get("/regions");
    this.availableRegions = orderBy([...regions], "name");
    this.sharedRegions = this.availableRegions;

    $(".regionSelect").select2({
      placeholder: "Selecciona una región",
      width: "100%",
    });
    $(".citySelect").select2({
      placeholder: "Selecciona una ciudad",
      width: "100%",
    });
    $(".communeSelect").select2({
      placeholder: "Selecciona una comuna",
      width: "100%",
    });
    $(".collegeSelected").select2({
      placeholder: "Selecciona un colegio",
      width: "100%",
    });
    $(".yearsSelected").select2({
      placeholder: "Año egreso",
      width: "100%",
    });
  },

  mounted() {
    //define empty default students data
    this.availableStudentsRegion.push(...this.students.map(() => []));
    this.formsComplete.push(...this.students.map(() => false));
    this.availableStudentsCommunes.push(...this.students.map(() => []));
    this.availableStudentsColleges.push(...this.students.map(() => []));
    this.availableStudentsServerColleges.push(...this.students.map(() => []));

    this.rehydrate();

    this.$Progress.finish();

    if (this.financingPartyData.regionId) {
      this.onSelectRegion();
    }
    this.interval = setInterval(this.discountSeconds, 1000);

    if (this.$route.query.transactionFailed) {
      //open modal
      const errName = this.$route.query.transactionFailed;
      if (errName === "err" || errName === "time_expired") {
        this.$refs.btnCancelPay.click();
        this.formsComplete = [true, ...this.studentsData.map(() => true)];
      }
    }
    $(document).ready(() => {
      this.validateForm(
        $("#programInscription"),
        {
          ["nombre-" + this.timestamp]: {
            required: true,
            lettersonly: true,
          },

          apellidoPaterno: {
            required: true,
            lettersonly: true,
          },

          apellidoMaterno: {
            required: true,
            lettersonly: true,
          },

          direccion: {
            required: true,
          },
          email: {
            minlength: 8,
            required: true,
            email: function (value, element) {
              // return /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test(
              return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
                value
              );
            },
          },
          ["region-" + this.timestamp]: {
            required: true,
          },
          ["ciudad-" + this.timestamp]: {
            required: true,
          },
          ["comuna-" + this.timestamp]: {
            required: true,
          },
          rut: {
            required: true,
            rut: true,
          },

          cel: {
            minlength: 13,
            required: true,
          },

          terminos: {
            required: true,
          },
        },

        {
          apellidoPaterno: {
            required: "Debes ingresar tu apellido paterno",
            lettersonly: "Solo se permiten letras",
          },

          apellidoMaterno: {
            required: "Debes ingresar tu apellido materno",
            lettersonly: "Solo se permiten letras",
          },

          nombre: {
            required: "Ingresa tu nombre",
            lettersonly: "Solo se permiten letras",
          },
          direccion: {
            required: "Debes ingresar una dirección",
          },
          email: {
            minlength: "Debes ingresar un correo valido",
            required: "Debes ingresar un correo",
            email: "Debes ingresar un correo valido",
          },
          ["region-" + this.timestamp]: {
            required: "Debes seleccionar una región",
          },
          ["ciudad-" + this.timestamp]: {
            required: "Debes seleccionar una ciudad",
          },
          ["comuna-" + this.timestamp]: {
            required: "Debes seleccionar una comuna",
          },
          rut: {
            required: "Debes ingresar el RUT",
            rut: "El RUT ingresado no es válido",
          },

          cel: {
            minlength: "Debes ingresar un numero de celular válido",
            required: "Debes ingresar un numero de celular",
          },

          terminos: {
            required: "Debes aceptar los terminos y condiciones",
          },
        }
      );
      setTimeout(() => {
        this.students.forEach((s, i) => {
          this.validateForm(
            $("#alumnForm" + i),
            {
              email: {
                email: function (value, element) {
                  return /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test(
                    value
                  );
                },
                minlength: 8,
                required: true,
              },
              cel: {
                minlength: 13,
                required: true,
              },

              ["colegio-" + this.timestamp]: {
                required: true,
              },
              ["region-" + this.timestamp]: {
                required: true,
              },
              ["comuna-" + this.timestamp]: {
                required: true,
              },

              promedio: {
                required: true,
              },

              añoGraduacion: {
                required: true,
              },

              fecha: {
                minlength: 10,
                required: true,
              },

              genero: {
                required: true,
              },
            },

            {
              email: {
                minlength: "Debes ingresar un correo valido",
                required: "Debes ingresar un correo",
                email: "Debes ingresar un correo valido",
              },
              cel: {
                minlength: "Debes ingresar un número de celular válido",
                required: "Debes ingresar un número de celular",
              },

              ["colegio-" + this.timestamp]: {
                required: "Debes ingresar un colegio",
              },
              ["region-" + this.timestamp]: {
                required: "Debes ingresar una región",
              },
              ["comuna-" + this.timestamp]: {
                required: "Debes ingresar una comuna",
              },

              promedio: {
                required: "Debes ingresar tu promedio",
              },

              añoGraduacion: {
                required: "Debes seleccionar un año",
              },

              fecha: {
                minlength: "Debe ingresar la fecha correctamente",
                required: "Debes ingresar tu fecha de nacimiento",
              },

              genero: {
                required: "Debes seleccionar tu género",
              },
            }
          );
        });
      }, 1000);
    });
  },

  filters: {
    timeRemaining(time) {
      return moment(time, "mm:ss").format("mm’ ss’’");
    },
  },
  watch: {
    sharedRegions(value) {
      if (value.length) {
        this.studentsData.forEach((student, i) => {
          this.$set(this.availableStudentsRegion, i, value);
        });
      }
    },
  },
};
</script>
<style lang="scss">
.swal2-styled.swal2-confirm {
  background-color: #000000 !important;
  border-radius: 2px !important;
  color: #ffd61a !important;
  min-width: 185px;
}
.vuejs-countdown {
  display: block;
  .text {
    display: none;
  }
  .digit {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 10px !important;

    color: #666666;
    line-height: 1px !important;
  }
  li::after {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 12px !important;
    color: #666666;
    line-height: 12px !important;
  }
}

.pdv-form-group .form-group input[type="search"] {
  border-radius: 100px !important;
  border: 2px solid $neutral30 !important;
  height: 48px !important;
  padding: 12px 24px !important;
}

.step-4-content {
  .form-group label {
    color: $neutralBlack !important;
    font-family: "Poppins-Medium", sans-serif !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 22px !important;
  }
}
</style>
<style scoped lang="scss">
.info-collected {
  display: flex;

  .info-collected-item {
    @media (max-width: 768px) {
      width: 100%;
    }
    @media (min-width: 769px) {
      width: 50%;
    }

    .key {
      color: $neutral70;
      font-family: "Poppins-Regular", sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }
    .value {
      color: $neutralBlack;
      font-family: "Poppins-Medium", sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
  }
}

.div-alinear {
  display: flex;
  gap: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (min-width: 769px) {
    flex-direction: row;
  }
  .item1 {
    @media (max-width: 768px) {
      width: 100%;
    }
    @media (min-width: 769px) {
      width: 70%;
      margin-right: 30px;
    }
  }
  .item2 {
    @media (max-width: 768px) {
      width: 100%;
      display: none;
    }
    @media (min-width: 769px) {
      width: 30%;
    }
  }
}

.seccion-separator {
  width: 100%;
  @media (max-width: 768px) {
    margin-top: 32px;
  }
  @media (min-width: 769px) {
    margin-top: 40px;
  }
}

.imagen-pensar {
  @media (min-width: 769px) {
    margin-top: -170px;
  }
}

.w-accordion-custom {
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (min-width: 769px) {
    width: 352px;
  }
}

.custom-padding {
  @media (max-width: 768px) {
    padding: 0 24px;
  }
  @media (min-width: 769px) {
    padding: 0 76px;
  }
}
.error-message {
  color: #ff0000 !important;
  font-size: 14px;
  font-weight: 900;
  position: absolute;
  bottom: -24px;
  left: 20px;
}

.step-4-content {
  padding: 45px 0 56px;
  @include media-breakpoint-down(sm) {
    padding-top: 0;
    padding-bottom: 125px;
  }
  i {
    left: 40%;
    top: 45%;
    &.success {
      color: green;
    }
    &.danger {
      color: red;
    }
  }
  .modal-step-4 {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5); /* Fondo oscuro semitransparente */
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    overflow: auto;
  }

  .modal-content-step4 {
    background-color: #fff;
    width: 90%;
    max-width: 400px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: relative;

    @media (max-width: 768px) {
      width: 90%;
    }
    @media (min-width: 769px) {
      width: 500px;
    }

    @media (max-width: 375px) {
      .modal-content-step4 {
        width: 100%;
        max-width: 320px;
        padding: 15px;
      }
    }

    .modal-step-4-header {
      margin-bottom: 10px;
      .btn-close {
        color: #332237;
        font-family: "Poppins-Medium", sans-serif;
        font-size: 24px;
      }
    }

    .otp-div {
      h2 {
        color: $neutralBlack;
        text-align: center;
        font-family: "Poppins-Bold", sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
      }
      .otp-info {
        color: $neutral80;
        text-align: center;
        /* Common/Body1/Regular */
        font-family: "Poppins-Regular", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        margin-bottom: 25px;
        .otp-info-email {
          color: #000;
          font-size: 17px;
          font-family: "Poppins-Medium", sans-serif;
        }
      }
      label {
        color: $neutralBlack;
        font-family: "Poppins-Medium", sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
      }
      .temporizador {
        display: flex;
      }
      .otp-info-clock {
        font-family: "Poppins-Regular", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        color: #999999;
        text-align: left;
        margin-top: 5px;
        padding-right: 12px;
        margin-left: 18px;
      }
      .btn-codigo {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .otp-error {
        margin-left: 9px;
        font-family: "Poppins-Regular", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        text-align: left;
        color: #ff0000;
      }
      .otp-row-padding {
        padding: 0px 30px 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .input-otp {
        padding: 0 15px;
        background-color: #ffffff;
        border-radius: 100px;
        border: 2px solid $neutral30;
        box-sizing: border-box;
        height: 46px;
        box-shadow: 0px 1px 2px rgba(50, 50, 71, 0.08),
          0px 0px 1px rgba(50, 50, 71, 0.2);
      }
      .otp-disclaimer {
        font-family: "Poppins-Regular", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 140%;
        color: #000000;
      }
      .otp-button {
        cursor: pointer;
        min-width: 151px;
        height: 46px;
        font-family: Gotham;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        text-transform: uppercase;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0px 2px 2px 0px;
        &.disabled {
          background: #999999 !important;
        }
        &.active {
          background: #000000;
          color: #ffd61a;
        }
      }
      .otp-check {
        margin-top: 7px;
        font-family: Lato;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        span {
          cursor: pointer;
          margin-left: 5px;
          font-family: Lato-Bold;
          font-weight: bold;
          text-decoration: underline;
        }
      }
    }
  }
}
.otp-verificado {
  color: #72c546;
  margin-left: 8px;
  font-family: Gotham Book;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
}
.disclaimer-info-otp {
  margin-left: 10px;
  cursor: pointer;
}

.validador-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.validador-container > div:first-child {
  display: flex;
  align-items: center; /* Para alinear verticalmente ícono y texto */
}

.otp-first-disclaimer {
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #353535;
  margin-left: 8px;
  margin-top: 15px;
  line-height: 0.2;
}

.validar {
  text-decoration: underline;
  cursor: pointer;
}

.otp-verificado-danger {
  cursor: pointer;
  color: red;
  margin-left: 8px;
  font-family: Gotham Book;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
}
.form-group {
  input[type="text"],
  input[type="email"] {
    border: 1.2px solid #000000;
  }
}

#formsList {
  .disabled {
    & div {
      opacity: 0.5;
      pointer-events: none;
    }
    &:hover {
      cursor: not-allowed;
    }
  }
}
.alert-info {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  background-color: inherit;
  position: sticky;
  width: 100%;
  top: 0;
  right: 0;
  div {
    background: $red-2;
    display: inline-flex;
    align-items: center;

    padding: 8px 25px;
    p {
      @include media-breakpoint-down(sm) {
        font-size: 11px;
      }
    }
  }
  @include media-breakpoint-down(sm) {
    width: calc(100% + 30px);
    position: sticky;
    right: unset;
    top: 65px;
    z-index: 999;
    margin-left: -15px;
    margin-right: -15px;
    justify-content: center;
    padding: 5px 4px;
  }

  img {
    width: 25px;
    @include media-breakpoint-down(sm) {
      width: 22px;
    }
  }

  p {
    color: #fff;
    font-size: 14px;
    @include alternative-light-regular;
    margin: 0 5px;
  }

  span {
    color: #fff;
    font-size: 20px;
    @include alternative-medium-regular;
    @include media-breakpoint-down(sm) {
      font-size: 18px;
    }
  }
}

.step-title {
  @include media-breakpoint-down(sm) {
    margin-top: 20px;
  }
  margin-bottom: 28px;

  h3 {
    font-size: 20px;
    @include alternative-bold;
    line-height: 23px;
    margin-bottom: 0;
  }

  p {
    font-size: 18px;
    line-height: 26px;
    @include alternative-regular;
    margin-bottom: 0;
  }
}

.check-box-text {
  span {
    color: $neutralBlack;
    font-family: "Poppins-Regular", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  a {
    color: #592466;
    font-family: "Poppins-Bold", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    text-decoration-line: underline;
  }
}
.list-header {
  .btn-pdv-collapse {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 18px;
    font-family: "ubunturegular", Arial, sans-serif;
    width: 100%;
    border: 1px solid #979797;
    background: transparent;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    span {
      font-size: 16px;
      line-height: 18px;
      color: #000;
      @include alternative-medium-regular;
    }

    width: 100%;

    &:not(.collapsed) img {
      transform: rotate(180deg);
    }
    &:focus {
      outline: none;
    }
  }
  &:hover {
    cursor: pointer;
  }
}
.input-hidden-college {
  position: absolute;
  left: -3000px;
  visibility: hidden;
  z-index: -1000;
}
.btn-pdv-primary {
  width: 100%;
  text-align: center;
  min-width: 220px;
  margin-top: 20px;
  &.disabled {
    background-color: #999999;
  }
}

#programInscription .row.form-group {
  margin-bottom: 1rem;
}

.pdv-submit-button {
  /*.form-group {
    margin-top: 0;
  }*/

  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}

.hidden-form {
  position: absolute;
  visibility: hidden;
}
.btn-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  @include media-breakpoint-down(sm) {
    width: 100%;
    .img-webpay {
      display: none;
    }
  }
}
.img-webpay {
  margin-left: 5px;
  width: 126px;
  height: 35px;
}
@media screen and (min-width: 320px) and (max-width: 480px) {
  .d-flex {
    display: block !important;
  }
  .step-4-content .disclaimer-info-otp {
    margin-left: 0px !important;
    margin-top: 12px !important;
  }
}

.flex-col {
  flex-direction: column;
}

.recomendation {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #69adf1;
  background: #f0f7ff;
  margin-bottom: 21px;
  padding: 12px 16px;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 15px;
  }

  .img-content {
    width: 141px;
    height: 100%;
    display: flex;
    align-items: flex-end;
    margin-right: 15px;
    @media (max-width: 768px) {
      display: none;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  .text-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    h5 {
      color: #115496;
      font-family: "Poppins-Medium", sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
    .item {
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      .bullet-yellow {
        margin-right: 15px;
        width: 5px;
        height: 5px;
        border-radius: 100%;
        background: #115496;
      }

      span {
        color: #115496;
        font-family: "Poppins-Medium", sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
      }
    }
  }
}

.form-group input[type="text"] {
  border-radius: 100px !important;
  border: 2px solid $neutral30 !important;
  height: 48px !important;
  padding: 12px 24px !important;
}

.form-group input[type="tel"] {
  border-radius: 100px !important;
  border: 2px solid $neutral30 !important;
  height: 48px !important;
  padding: 12px 24px !important;
}

.form-group input[type="email"] {
  border-radius: 100px !important;
  border: 2px solid $neutral30 !important;
  height: 48px !important;
  padding: 12px 24px !important;
}

.input-container {
  position: relative;
}

.error-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  z-index: 20;
}

@media (max-width: 768px) {
  .error-icon {
    right: 20px;
  }
}

.modal-intensive {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
  display: flex;
  align-items: center;
  height: 100vh;
  background: rgba(134, 133, 133, 0.1);

  .content {
    position: relative;
    width: 40%;
    border-radius: 24px;
    border: 2px solid $neutralBlack;
    background: $neutralwhite;
    padding: 24px;
    box-shadow: 0 0 12px 3px #00000038;
    min-height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include media-breakpoint-down(sm) {
      width: 90%;
    }

    .header {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .btn-modal {
        font-size: 30px;
        border: none;
        background: transparent;
        color: #fff;
        &:hover {
          cursor: pointer;
        }
      }
    }

    .text-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      padding: 0 70px;

      h5 {
        color: $neutralBlack;
        text-align: center;
        font-family: "Poppins-Bold", sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
        margin-bottom: 10px;
      }

      p {
        color: $neutral80;
        text-align: center;
        font-family: "Poppins-Regular", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 0px;

        span {
          font-family: "Poppins-Bold", sans-serif;
          font-weight: 700;
        }
      }
    }
  }
}

.img-modal-loading {
  position: absolute;
  right: 20px;
  bottom: 20px;
  height: 70%;

  @media (max-width: 768px) {
    display: none;
  }
}
</style>
